 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781416546375_COV from '@/components/9781416546375_cov'
 import A781416546375_REW01 from '@/components/9781416546375_rew01'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import A781416546375_TIT01 from '@/components/9781416546375_tit01'
 import A781416546375_DED01 from '@/components/9781416546375_ded01'
 import A781416546375_FM01 from '@/components/9781416546375_fm01'
 import A781416546375_FM02 from '@/components/9781416546375_fm02'
 import A781416546375_FM03 from '@/components/9781416546375_fm03'
 import A781416546375_FM04 from '@/components/9781416546375_fm04'
 import A781416546375_PT01 from '@/components/9781416546375_pt01'
 import A781416546375_PT02 from '@/components/9781416546375_pt02'
 import A781416546375_PT03 from '@/components/9781416546375_pt03'
 import A781416546375_BM01 from '@/components/9781416546375_bm01'
 import SS_RECOMMENDPAGE from '@/components/SS_recommendpage'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
 import A781416546375_COP01 from '@/components/9781416546375_cop01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781416546375_cov",
 			"name" : "9781416546375_cov",
 			"component" : A781416546375_COV
 		},
 		{
 			"path" : "/9781416546375_rew01",
 			"name" : "9781416546375_rew01",
 			"component" : A781416546375_REW01
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9781416546375_tit01",
 			"name" : "9781416546375_tit01",
 			"component" : A781416546375_TIT01
 		},
 		{
 			"path" : "/9781416546375_ded01",
 			"name" : "9781416546375_ded01",
 			"component" : A781416546375_DED01
 		},
 		{
 			"path" : "/9781416546375_fm01",
 			"name" : "9781416546375_fm01",
 			"component" : A781416546375_FM01
 		},
 		{
 			"path" : "/9781416546375_fm02",
 			"name" : "9781416546375_fm02",
 			"component" : A781416546375_FM02
 		},
 		{
 			"path" : "/9781416546375_fm03",
 			"name" : "9781416546375_fm03",
 			"component" : A781416546375_FM03
 		},
 		{
 			"path" : "/9781416546375_fm04",
 			"name" : "9781416546375_fm04",
 			"component" : A781416546375_FM04
 		},
 		{
 			"path" : "/9781416546375_pt01",
 			"name" : "9781416546375_pt01",
 			"component" : A781416546375_PT01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js